const arrayRegex = /\.(\d+)(?=\.|$)/g;

/**
 * Normalizes the path to the kind that formik actually uses for errors.
 * @example `a.0.b` -> `a[0].b`
 * See the nearby associated unit test for examples.
 */
export function normalizePath(path: string): string {
  for (const match of path.matchAll(arrayRegex)) {
    // eslint-disable-next-line no-param-reassign
    path = path.replace(match[0], `[${match[1]}]`);
  }

  return path;
}
